var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{on:{"click":_vm.onclick}},[(_vm.status === 'loading')?_c('mini-loader',{attrs:{"h":"12","w":"12","color":"#333"}}):_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }